import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  error: {
    status: '',
    message: '',
  },
  types: {
    video: 'video',
    pdf: 'pdf',
  },
  program: null,
};

const createProgramSlice = createSlice({
  name: 'createProgram',
  initialState,
  reducers: {
    GET_PROGRAM: state => ({
      ...state,
      isLoading: true,
      error: initialState.error,
    }),
    GET_PROGRAM_SUCCESS: (state, { payload }) => ({
      ...state,
      isLoading: false,
      program: payload.program,
    }),
    GET_PROGRAM_FAIL: (state, { payload }) => ({
      ...state,
      isLoading: false,
      error: payload.error,
    }),
    CHANGE_NAME_PROGRAM: (state, { payload }) => ({
      ...state,
      program: { ...state.program, name: payload.name },
    }),
    RESET_STATE: () => ({ ...initialState }),
  },
});

export const {
  GET_PROGRAM,
  GET_PROGRAM_FAIL,
  GET_PROGRAM_SUCCESS,
  CHANGE_NAME_PROGRAM,
  RESET_STATE,
} = createProgramSlice.actions;

export const createProgramSelector = state => state.createProgram;

export default createProgramSlice.reducer;
